import React, { useMemo } from "react";
import { BlockStack, Card, InlineStack, Select, Text } from "@shopify/polaris";

interface LeaveTimeRangeSelectorProps {
  startTime: string;
  endTime: string;
  onStartTimeChange: (value: string) => void;
  onEndTimeChange: (value: string) => void;
  startLabel: string;
  endLabel: string;
}

function buildTimeOptions() {
  const options = [{ label: "--:--", value: "" }];
  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += 30) {
      const hh = String(hour).padStart(2, "0");
      const mm = String(minute).padStart(2, "0");
      const v = `${hh}:${mm}`;
      options.push({ label: v, value: v });
    }
  }
  return options;
}

export function LeaveTimeRangeSelector({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
  startLabel,
  endLabel,
}: LeaveTimeRangeSelectorProps) {
  const options = useMemo(buildTimeOptions, []);

  return (
    <Card>
      <BlockStack gap="300">
        <Text as="p" variant="headingSm">
          Time range
        </Text>
        <InlineStack gap="300" wrap>
          <div style={{ minWidth: 180, flex: 1 }}>
            <Select
              label={startLabel}
              options={options}
              value={startTime || ""}
              onChange={onStartTimeChange}
            />
          </div>
          <div style={{ minWidth: 180, flex: 1 }}>
            <Select
              label={endLabel}
              options={options}
              value={endTime || ""}
              onChange={onEndTimeChange}
            />
          </div>
        </InlineStack>
      </BlockStack>
    </Card>
  );
}
